// extracted by mini-css-extract-plugin
module.exports = {"privilegePicker":"PrivilegesAdd_privilegePicker__1M5fm","select":"PrivilegesAdd_select__eEG4d","limitIcon":"PrivilegesAdd_limitIcon__2v5Ji"};